<template>
  <div id="order-certificates">
    <!-- Back -->
    <CRow>
      <CCol lg="12">
        <div class="d-flex align-items-center justify-content-end mb-3">
          <a
            href="javascript:void(0)"
            @click="$router.go(-1)"
          ><CIcon
            name="cil-arrow-left"
            class="mr-2"
          />Voltar</a>
        </div>
      </CCol>
    </CRow>
    <!-- Content -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">
              Certificados - Ordernar
            </h4>
          </CCardHeader>

          <CCardBody>
            <!-- Filter -->
            <CRow>
              <CCol>
                <label class="mb-2">
                  Filtro
                </label>
              </CCol>
            </CRow>
            <CRow>
              <CCol
                lg="3"
                class="mb-4"
              >
                <Multiselect
                  :value="categoryOptions.find(option => option.value == query.category)"
                  :options="categoryOptions"
                  label="label"
                  track-by="value"
                  @select="(selected) => query.category = selected.value"
                />
              </CCol>
            </CRow>

            <!-- Sortable -->
            <CRow>
              <CCol col="12">
                <Sortable
                  :items="datatable.items"
                  :fields="datatable.fields"
                  :enable-switch-status="false"
                  :enable-export="false"
                  @endDragging="endDragging"
                >
                </Sortable>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
// Components
import Sortable from '@/components/ui/Sortable'
import Multiselect from '@/components/ui/Multiselect'

// Dependencies
import { orderBy, debounce } from 'lodash'

// Services
import Service from '@/services/certificates.service'

export default {
  metaInfo: {
    title: 'Certificados',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_certificates')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    Sortable,
    Multiselect
  },

  data() {
    return {
      datatable: {
        items: [],
        fields: [
          {
            key: 'status',
            label: 'Status',
            sorter: false,
            _style: 'width: 8%; min-width: 100px;'
          },
          {
            key: 'title',
            label: 'Título',
            sorter: false,
            thumb: true
          }
        ]
      },
      categoryOptions: [
        {
          label: 'Certificados',
          value: '1'
        },
        {
          label: 'Selos Sociais',
          value: '2'
        },
        {
          label: 'Prêmios',
          value: '3'
        }
      ],
      query: {
        search: '',
        page: 1,
        perpage: localStorage.getItem('perPageItem')
          ? parseFloat(localStorage.getItem('perPageItem'))
          : 10,
        pagination: false,
        status: true,
        category: 1,
        sorter: {
          asc: false,
          column: ''
        }
      },
      processing: false
    }
  },

  watch: {
    query: {
      handler: 'updateDataTable',
      deep: true
    }
  },

  async created() {
    await this.updateDataTable()
  },

  methods: {
    async updateDataTable() {
      const response = await Service.index(this.query)

      if (response.data) {
        const newItems = response.data.map((item) => {
          return {
            ...item,
            thumb: item.main_image.length > 0 ? item.main_image[0].url : null,
            status: !!item.status
          }
        })

        this.datatable.items = orderBy(newItems, ['order'])
      }
    },

    endDragging: debounce(function(items) {
      this.datatable.items = items
      Service.updateOrder(this.datatable.items)

      this.$notify({
        group: 'notifications',
        type: 'success',
        text: 'Ordenação alterada com sucesso.'
      })
    }, 1000)
  }
}
</script>

<style lang="scss">
#order-certificates {
  .orderButton {
    margin-right: 10px;
  }

  .thumb {
    width: 80px !important;
  }
}
</style>
